var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { tokenService } from "sbtech-sports-data-api-client";
/**
 * Global configuration for SportDataApi/BFF
 */
var GlobalConfigs = /** @class */ (function () {
    function GlobalConfigs(config) {
        this.apiConfigs = config.apiConfigs;
        this.authorization = config.authorization;
        this.currencySettings = config.currencySettings;
    }
    GlobalConfigs.prototype.setAuthorization = function (authorization) {
        this.authorization = authorization;
        tokenService.apiAccessToken = authorization.token;
    };
    GlobalConfigs.prototype.getAuthorization = function () {
        return this.authorization;
    };
    return GlobalConfigs;
}());
export { GlobalConfigs };
export var GlobalConfig = new GlobalConfigs({
    apiConfigs: {
        sportDataApiUrl: "",
        bffApiUrl: "",
        locale: "",
        betsApiUrl: ""
    },
    authorization: {
        token: ""
    },
    currencySettings: {
        code: "",
        sign: "",
        format: ""
    }
});
/**
 * init function initialize GlobalConfig object
 * @param config {GlobalConfig} config object to override the default values
 */
export var init = function (config) {
    !Object.isFrozen(GlobalConfig.apiConfigs)
        && (GlobalConfig.apiConfigs = __assign({}, GlobalConfig.apiConfigs, config.apiConfigs))
        && Object.freeze(GlobalConfig.apiConfigs);
    GlobalConfig.currencySettings = __assign({}, GlobalConfig.currencySettings, config.currencySettings);
    GlobalConfig.setAuthorization(__assign({}, GlobalConfig.getAuthorization(), config.authorization));
};
//# sourceMappingURL=init.js.map